'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { LoginLinkTappedProps, TrackingFunction } from '../types';

export const useLoginLinkTracking = (props: LoginLinkTappedProps, autoTrack: boolean = false): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.LOGIN_LINK_TAPPED,
      properties: props,
      opts: { shouldSendToFacebook: true },
    },
    autoTrack,
  );
};
